import { Major } from '@common-types';
import { baseService } from '@services/base.service';
import { SLIDER_ITEMS_LIMIT } from '@constants';

export interface BaseHomePageData {
  careerFitMajors: Major[];
  careerFavoriteMajors: Major[];
}

export async function getBaseHomePageData(): Promise<BaseHomePageData> {
  const [careerFitMajors, careerFavoriteMajors] = await Promise.all([
    baseService.getAsync<{ majors: Major[] }>(`/majors?limit=${SLIDER_ITEMS_LIMIT}&careerFit=true`),
    baseService.getAsync<{ majors: Major[] }>(`/majors?limit=${SLIDER_ITEMS_LIMIT}&careerFavorite=true`),
  ]);

  return {
    careerFitMajors: careerFitMajors.majors,
    careerFavoriteMajors: careerFavoriteMajors.majors,
  };
}
